// Phase I0.3 — StrengthDots primitive.
// 1–5 coloured dots representing signal strength.

import type { CSSProperties } from "react";

export interface StrengthDotsProps {
  /** Number of filled dots. Clamped to [0, total]. */
  n: number;
  /** Total dots in the row. Default 5. */
  total?: number;
  /** Override fill colour. Defaults to --sa-accent-saffron. */
  color?: string;
  style?: CSSProperties;
}

export function StrengthDots({ n, total = 5, color, style }: StrengthDotsProps) {
  const filled = Math.max(0, Math.min(total, Math.round(n)));
  return (
    <span style={{ display: "inline-flex", gap: 3, ...style }}>
      {Array.from({ length: total }).map((_, i) => (
        <span
          key={i}
          aria-hidden
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background:
              i < filled
                ? (color ?? "var(--sa-accent-saffron)")
                : "var(--sa-hairline-bright)",
          }}
        />
      ))}
    </span>
  );
}
